var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 28H60L56 24H40L36 28H32C27.6 28 24 31.6 24 36V60C24 64.4 27.6 68 32 68H64C68.4 68 72 64.4 72 60V36C72 31.6 68.4 28 64 28ZM48 56C43.6 56 40 52.4 40 48C40 43.6 43.6 40 48 40C52.4 40 56 43.6 56 48C56 52.4 52.4 56 48 56Z",
    fill: "url(#gradient-center)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2793 2.03997L52.1993 19.96V8.15997C71.0793 10.04 86.1193 25.08 87.9993 43.96H95.9993C93.3593 12.08 61.9593 -6.36003 34.2793 2.03997Z",
    fill: "url(#gradient1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 87.84C24.92 85.96 9.88 70.92 8 52.04H0C2.64 83.92 34.04 102.36 61.72 93.96L43.8 76.04V87.84Z",
    fill: "url(#gradient2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-center",
    x1: 48,
    y1: 24,
    x2: 48,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B37E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient1",
    x1: 65.1393,
    y1: 0.0136719,
    x2: 65.1393,
    y2: 43.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B37E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient2",
    x1: 30.86,
    y1: 52.04,
    x2: 30.86,
    y2: 95.9863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B37E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7D4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCamera);
export default __webpack_public_path__ + "static/media/SwitchCamera.e74c94e95c853359b0a7b9507fa5b124.svg";
export { ForwardRef as ReactComponent };